import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ScheduleIcon from '@mui/icons-material/Schedule';
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

import Question from '../../components/Question';
import ContinueButton from "../../components/ContinueButton";
import InfoCard from "../../components/InfoCard";

export default function AppointmentExpectations(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const patient = location?.state?.patient;

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/anything-else-toknow', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            backgroundColor="#82B1FF33"
            componentHeight="100vh"
            title={"Here's what's next"}
            input={
                <>

                    <InfoCard
                        icon={ScheduleIcon}
                        title="Now Let's book your appointment"
                        note="Be seen this week"
                    // description="Be seen this week"
                    />

                    <ContinueButton
                        sx={{ mt: 2 }}
                        onClick={() => {
                            setPageAndDeferNavigate(dispatch, '/appointment', () =>
                                navigate('/appointment', { state: { expectationData: patient } })
                            );
                        }}
                        title="Let's Go"
                        selected={true}
                    />
                </>
            }
            {...props}
        />
    );
}
